import { Text } from '@telegram-apps/telegram-ui';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

export const VoiceModalListeningHintsHeading: FC = () => {
  const { t } = useTranslation();
  return (
  <Text
    style={{
      fontSize: 11,
      fontWeight: 600,
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
      color: 'var(--tg-theme-hint-color)',
      opacity: 0.8,
      marginBottom: 8,
      display: 'block',
    }}
  >
    {t('voice.trySaying')}
  </Text>
  );
};
